// Store policy pages. Plain-language, honest defaults the owner can adjust anytime.
export const POLICIES = {
  shipping: {
    title: "Shipping & Processing Policy",
    updated: "October 12, 2026",
    sections: [
      {
        h: "Processing time",
        body: "Physical orders are processed and shipped within 3–5 business days of payment. You will receive an order confirmation email as soon as your purchase is complete.",
      },
      {
        h: "Shipping cost",
        body: "Physical orders ship for a flat $12.00 shipping fee per order, shown clearly at checkout before you pay.",
      },
      {
        h: "Where we ship",
        body: "We currently ship to addresses in the United States and Canada. If you are ordering for an organization or need a larger shipment, contact us for a custom quote.",
      },
      {
        h: "Digital products",
        body: "Digital products (such as the Extra UNSTUCK Bucks printable PDF, and the instructions and Bucks PDFs included with the Complete UNSTUCK Seniors Program) are delivered by secure download immediately after payment. Nothing physical ships for a digital-only order.",
      },
      {
        h: "Questions about an order",
        body: "Email us at Unstuckbytammi@gmail.com or use the Contact page and we will help.",
      },
    ],
  },
  returns: {
    title: "Returns & Refunds Policy",
    updated: "October 12, 2026",
    sections: [
      {
        h: "Damaged or incorrect items",
        body: "If your order arrives damaged or incorrect, contact us within 14 days of delivery at Unstuckbytammi@gmail.com with your order details and we will make it right.",
      },
      {
        h: "Digital products",
        body: "Digital downloads (including the Extra UNSTUCK Bucks PDF and the PDF support materials included with the Complete UNSTUCK Seniors Program) cannot be returned once delivered.",
      },
      {
        h: "Other returns",
        body: "For any other return request, contact us within 14 days of delivery and we will work with you. Items must be unused and in their original packaging.",
      },
      {
        h: "How refunds are issued",
        body: "Approved refunds are issued to the original payment method through our payment processor, Stripe.",
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    updated: "October 12, 2026",
    sections: [
      {
        h: "What we collect",
        body: "When you place an order we collect the information needed to fulfill it: your name, email address, and shipping address. When you send us a message through the Contact or Organization Pricing forms, we collect the details you provide so we can respond.",
      },
      {
        h: "Payments",
        body: "Payments are processed securely by Stripe. We never see or store your card number on our servers.",
      },
      {
        h: "How we use your information",
        body: "We use your information to fulfill orders, deliver digital purchases, respond to enquiries, and send order-related emails such as your order confirmation. We do not sell your personal information.",
      },
      {
        h: "Your choices",
        body: "You can ask us to correct or delete your personal information at any time by emailing Unstuckbytammi@gmail.com.",
      },
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "October 12, 2026",
    sections: [
      {
        h: "Our products",
        body: "UNSTUCK sells physical activity card decks and digital printable PDF support materials. UNSTUCK decks are everyday activity cards — they are not medical treatment, therapy, or a cure, and nothing on this site is medical advice.",
      },
      {
        h: "UNSTUCK Bucks",
        body: "UNSTUCK Bucks are an optional motivational reward system. They are game pieces only — GAME USE ONLY • NO CASH VALUE — and are not real money, gift cards, or legal tender.",
      },
      {
        h: "Digital downloads",
        body: "Purchased PDF files may be printed for personal or internal program use only. No resale or redistribution of the digital files or printed copies is permitted.",
      },
      {
        h: "Acceptable use",
        body: "You agree to use this site lawfully and not to interfere with its operation or attempt to access restricted areas.",
      },
      {
        h: "Contact",
        body: "Questions about these terms: Unstuckbytammi@gmail.com.",
      },
    ],
  },
};

export const POLICY_LINKS = [
  { to: "/policies/shipping", label: "Shipping & Processing" },
  { to: "/policies/returns", label: "Returns & Refunds" },
  { to: "/policies/privacy", label: "Privacy Policy" },
  { to: "/policies/terms", label: "Terms of Use" },
];
